import {
  isEmailValid,
  alphaOnly,
  stringLengthCalculator,
  alphaNumOnly,
} from "../common/Util";

interface RegistrationInput {
  Password?: string;
  [key: string]: any;
}

function isEmpty(input: string): boolean {
  return stringLengthCalculator(input) === 0;
}

function isTooShort(input: string, minLength: number): boolean {
  return stringLengthCalculator(input) < minLength;
}

function handleNameField(key: string, input: string): string | null {
  if (isEmpty(input)) {
    return `Please enter ${key === "firstName" ? "first name" : "last name"}`;
  }
  if (isTooShort(input, 3)) {
    return "Too Short (min 3 characters)";
  }
  if (!alphaOnly(input)) {
    return "Only Alphabets Allowed";
  }
  return null;
}

function handleUsernameField(input: string): string | null {
  if (isEmpty(input)) {
    return "Please enter UserName";
  }
  if (isTooShort(input, 6)) {
    return "Too Short (min 6 characters)";
  }
  if (!alphaNumOnly(input)) {
    return "Only Alphanumeric Allowed";
  }
  return null;
}

function handleEmailField(input: string): string | null {
  if (isEmpty(input)) {
    return "Please enter email";
  }
  if (!isEmailValid(input)) {
    return "Please enter valid Email.";
  }
  return null;
}

function handlePasswordField(input: string): string | null {
  if (isEmpty(input)) {
    return "Please enter Password";
  }
  if (isTooShort(input, 6)) {
    return "Password should be at least 6 characters";
  }
  return null;
}

function handleConfirmPasswordField(
  input: string,
  password?: string
): string | null {
  if (isEmpty(input)) {
    return "Please enter confirm password";
  }
  if (input !== password) {
    return "Password not matching";
  }
  return null;
}

function handleSimpleField(key: string, input: string): string | null {
  return isEmpty(input) ? `Please enter ${key}` : null;
}

export function errorMessage(
  key: string,
  input: string,
  registrationInput: RegistrationInput
): string | null {
  switch (key) {
    case "firstName":
    case "lastName":
      return handleNameField(key, input);
    case "UserName":
      return handleUsernameField(input);
    case "email":
      return handleEmailField(input);
    case "Password":
      return handlePasswordField(input);
    case "confirmPassword":
      return handleConfirmPasswordField(input, registrationInput.Password);
    case "username":
    case "password":
      return handleSimpleField(key, input);
    default:
      return null;
  }
}
